import http from '@/util/http'

class CompanyInfo {
  //所有公司
  getAllCompany(data) {
    let url = '/share-foreign/api/company/getAllCompany';
    return http.post(url, data);
  }

  //当前登录人及其子公司
  getSubComany(data) {
    let url = '/share-foreign/api/company/getSubCompany';
    return http.post(url, data);
  }

  //二级公司
  getSecondCompany(data) {
    let url = '/share-foreign/api/company/getSecondCompany';
    return http.post(url, data);
  }

  //获取本公司下部门信息
  getDeptByCompanyId(data) {
    let url = '/share-foreign/api/dept/getDeptByCompanyId';
    return http.post(url, data);
  }

  //集团公司及当前登录人公司
  getCompanyAndGroupCompany(data) {
    let url = '/share-foreign/api/company/getCompanyAndGroupCompany';
    return http.post(url, data);
  }

  //二级公司为当前公司集团公司为获取二级公司
  getCompanyLevelTwoIfYes(data) {
    let url = '/share-foreign/api/company/getCompanyLevelTwoIfYes';
    return http.post(url, data);
  }

  //当前登录人的子公司（不包含本公司）
  getSubCompanyByCompanyId(data) {
    let url = '/share-foreign/api/company/getSubCompanyByCompanyId';
    return http.post(url, data);
  }

  //获取公司下对应的职务列表
  getDutyListByCompanyIdV2(data) {
    let url = '/share-foreign/api/dept/getDutyListByCompanyIdV2';
    return http.post(url, data);
  }
  // 获取公司签发人
  getCompanySigner(data){
    let url = "/share-foreign/entRecord/getSigner"
    return http.post(url,data)
  }
}

export default CompanyInfo
